import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';

@Component({
    templateUrl: './dynamic-map.component.html'
})
export class DynamicMapComponent implements OnInit {
    latitude: number;
    longitude: number;
    zoom = 20;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

    ngOnInit() {
        const { Latitude, Longitude } = this.config.data;

        this.latitude = Latitude;
        this.longitude = Longitude;
    }
}
